var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "0px 3%"
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.from,
      "rules": _vm.rules,
      "label-width": "170px"
    }
  }, [_c('div', [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('h2', {
    staticStyle: {
      "color": "#006E4B"
    }
  }, [_vm._v("身份证")])]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticStyle: {
      "width": "90%",
      "border": "1px solid #e9e9e9",
      "border-radius": "5px",
      "padding": "0 10px",
      "height": "100px"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "margin": "13px 0px"
    },
    attrs: {
      "span": 6
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/icon/文件类型-附件@2x.png"),
      "width": "65px",
      "height": "73px"
    }
  })]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin": "30px 0px"
    },
    attrs: {
      "span": 12
    }
  }, [_c('span', [_vm._v("王梦琪-身份证附件.jpg")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "15px",
      "color": "#929292"
    }
  }, [_vm._v("32kb")])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin": "36px 0px"
    },
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    staticStyle: {
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("\n                                    下载附件")])], 1)], 1)], 1)])], 1)], 1)])], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-596da813","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/Ygxxlb/tabsEdit/accessory.vue
// module id = null
// module chunks = 